import styles from "../styles/globalStyles.module.css";
import { Box, Divider, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import NotificationModal from "./NotificationModal";
import { Link, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authSelector, logoutUser } from "../redux/slices/authSlice";
// import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { walletSelector } from "../redux/slices/walletSlice";
import {
  FaQuestionCircle,
  FaUserCircle,
  FaWhatsapp,
} from "react-icons/fa";
import NewConnectStoreModal from "../portals/customer/pages/dashboard/components/NewConnectStoreModal";
import { storeSelector } from "../redux/slices/storeSlice";
import { ReactComponent as Payment } from "../assets/img/payment.svg";
import { ReactComponent as Setting } from "../assets/img/setting.svg";
import { ReactComponent as Logout } from "../assets/img/logout.svg";
import WhatsAppIcon from "../portals/customer/assets/whatsapp.jpeg";
import { KeyboardArrowDown } from "@mui/icons-material";
import { BsQuestionCircle } from "react-icons/bs";
import { RiWhatsappFill } from "react-icons/ri";
import NewStoreConnectWithStoreListModal from "../portals/customer/pages/dashboard/components/NewStoreConnectWithStoreListModal";
import useDecodedToken from "../hooks/useDecodeToken";

export default function Topbar() {
  const { announcement, shopifyAppStore, shopifyAppUserDetails  } = useSelector(storeSelector);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isBlur, setIsBlur] = useState(false);
  const open = Boolean(anchorEl);

  const decodedToken = useDecodedToken();

  const userDetails = shopifyAppStore?.shop_details || shopifyAppUserDetails?.shop_details

  const dispatch = useDispatch();
  const { loggedUser, profileImg } = useSelector(authSelector);
  const { wallet } = useSelector(walletSelector);

  const handleClick = (event) => {
    setIsBlur(!isBlur);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setIsBlur(!isBlur);
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  const liveAnnouncement =
    announcement?.announcement?.length > 0 && announcement?.announcement[0];

  // const location = useLocation().pathname;

  const productsLocation = loggedUser?.user?.role !== "admin";

  console.log("userDetails?.shop_owner", userDetails?.shop_owner)

  return (
    <Box>
      <div
        className={styles.navbar}
        style={{
          top:
            liveAnnouncement && loggedUser?.user?.role !== "admin"
              ? 33.5
              : "0px",
          // backgroundColor: productsLocation ? "#220d48" : '',
          background: productsLocation
            ? "linear-gradient(280deg, #341073 0%, #210D44 101.66%)"
            : "",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
          {productsLocation ? (
            <a
              href="https://api.whatsapp.com/send?phone=31642793793"
              target="_blank"
              rel="noreferrer"
            >
              <RiWhatsappFill
                style={{
                  color: productsLocation ? "#fff" : "#000",
                  fontSize: "20px",
                  // borderRadius: "50%",
                  marginRight: "20px",
                  marginTop:'8px'
                }}
              />
            </a>
          ) : (
            <FaWhatsapp
              style={{
                fontSize: "20px",
                borderRadius: "50%",
                marginRight: "20px",
              }}
            />
          )}
          {productsLocation ? (
            <a
              href="/help/"
              target="_blank"
              rel="noreferrer"
            >
              <FaQuestionCircle
                style={{
                  color: productsLocation ? "#fff" : "#000",
                  fontSize: "20px",
                  marginTop:'8px'
                }}
              />
            </a>
          ) : (
            <BsQuestionCircle
              style={{
                color: productsLocation ? "#fff" : "#000",
                fontSize: "20px",
              }}
            />
          )}
          {loggedUser?.user?.role !== "admin" && (
            <div style={{ display: "flex", justifySelf: "center" }}>
              <NotificationModal loggedUser={loggedUser} />
            </div>
          )}
          </div>

          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              marginRight: "7px",
            }}
          >
            {isBlur && (
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  // background: "rgba(0, 0, 0, 0.7)",
                  borderRadius: "50%",
                  zIndex: 999,
                }}
              />
            )}
            {profileImg || loggedUser?.user?.img ? (
              <img
                src={profileImg || loggedUser?.user?.img}
                alt="profile"
                style={{
                  width: "35px",
                  height: "35px",
                  // marginRight: "15px",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
                onClick={handleClick}
              />
            ) : (
              <FaUserCircle
                size={24}
                color={loggedUser?.user?.role === "admin"?"rgb(99, 115, 129)":"white"}
                style={{ marginLeft: "10px" }}
                onClick={handleClick}
              />
            )}
            <div style={{ marginLeft: "10px" }} onClick={handleClick}>
              <h4
                style={{
                  color: productsLocation ? "#fff" : "#000",
                  fontSize: "16px",
                  marginTop: -15,
                }}
              >
                {userDetails?.shop_owner ? userDetails?.shop_owner:decodedToken?.email ? "New Member" : loggedUser?.user?.first_name +
                  " " +
                  loggedUser?.user?.last_name || ""}
              </h4>
              <h6
                style={{ margin: 0, color: productsLocation ? "#fff" : "#000" }}
              >
                {userDetails?.owner_email || decodedToken?.email || loggedUser?.user?.email}
              </h6>
            </div>
            <KeyboardArrowDown
              style={{
                fontSize: "20px",
                color: productsLocation ? "#fff" : "#000",
                marginLeft: "10px",
              }}
              onClick={handleClick}
            />
          </div>

          <div>
            <Menu
              sx={{
                ".MuiMenu-paper": {
                  width: "230px",
                  left: "auto!important",
                  right: "29px!important",
                  overflow: "visible",
                },
              }}
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <span
                style={{
                  width: "12px",
                  height: "12px",
                  content: "",
                  left: "82%",
                  top: -5,
                  display: "block",
                  position: "absolute",
                  transform: "rotate(-135deg)",
                  background: "rgb(255, 255, 255)",
                }}
              ></span>
              <Box sx={{ marginLeft: "20px", marginBottom: "2px" }}>
                <Typography
                  sx={{
                    fontWeight: 600,
                  }}
                >
                  {loggedUser?.user?.last_name ? (
                    <>
                      {loggedUser?.user?.first_name +
                        " " +
                        loggedUser?.user?.last_name}
                    </>
                  ) : (
                    <>{loggedUser?.user?.first_name}</>
                  )}
                </Typography>
                <Typography
                  sx={{
                    fontSize: 12,
                  }}
                >
                  {loggedUser?.user?.email
                    ? loggedUser?.user?.email
                    : "Not available"}
                </Typography>
                <Typography
                  sx={{
                    fontSize: 12,
                    fontWeight: 500,
                  }}
                >
                  {loggedUser?.user?.role !== "admin" ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <b>€{Math.floor(wallet?.available_balance) || 0}</b>{" "}
                      <span style={{ margin: "0 2px 0 2px" }}> - </span>
                      <Link
                        to="/customer/payments"
                        style={{
                          fontSize: 12,
                          fontWeight: 500,
                          display: "flex",
                          justifySelf: "center",
                          color: "#3e3e3e",
                          cursor: "pointer",
                        }}
                      >
                        recharge
                      </Link>
                    </div>
                  ) : (
                    "Admin"
                  )}
                </Typography>
              </Box>
              <Divider sx={{ borderStyle: "dotted" }} />
              {loggedUser?.user?.role !== "admin" &&
               <NewStoreConnectWithStoreListModal />}
              <Link
                to={
                  loggedUser?.user?.role !== "admin"
                    ? "/customer/payments"
                    : "/admin/payments"
                }
              >
                <MenuItem
                  sx={{ fontSize: "14px", color: "#9d9d9d" }}
                  onClick={handleClose}
                >
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        display: "flex",
                        alignSelf: "center",
                        marginRight: "5px",
                      }}
                    >
                      {/* <MdOutlinePayment size={16} style={{ color: "black" }} /> */}
                      <Payment width="16" height="16" />
                    </div>
                    <p style={{ fontWeight: 400 }}>Payments</p>
                  </div>
                </MenuItem>
              </Link>
              {loggedUser?.user?.role !== "admin" && (
                <Link to="/customer/setting">
                  <MenuItem
                    sx={{ fontSize: "14px", color: "#9d9d9d" }}
                    onClick={handleClose}
                  >
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          display: "flex",
                          alignSelf: "center",
                          marginRight: "5px",
                        }}
                      >
                        {/* <MdOutlineSettings
                          size={16}
                          style={{ color: "black" }}
                        /> */}
                        <Setting width="16" height="16" />
                      </div>
                      <p style={{ fontWeight: 400 }}>Setting</p>
                    </div>
                  </MenuItem>
                </Link>
              )}
              <MenuItem
                sx={{
                  fontSize: "14px",
                  color: "#9d9d9d",
                  "& .MuiSvgIcon-root": {
                    fontSize: "16px",
                  },
                }}
                onClick={handleClose}
              >
                <a
                  href="https://api.whatsapp.com/send?phone=31642793793"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ display: "flex", justifySelf: "center" }}>
                      {/* <WhatsAppIcon
                        sx={{
                          cursor: "pointer",
                          marginRight: "5px",
                          color: "black",
                        }}
                      /> */}
                      <img
                        src={WhatsAppIcon}
                        style={{
                          height: "16px",
                          width: "16px",
                          marginRight: "5px",
                        }}
                        alt="whatsapp"
                      />
                    </div>
                    <p style={{ margin: 0, fontWeight: 400 }}>
                      Contact an agent
                    </p>
                  </div>
                </a>
              </MenuItem>
              <Divider
                sx={{ borderStyle: "dotted", borderWidth: "0px 0px thin" }}
              />
              <MenuItem
                sx={{
                  fontSize: "14px",
                  color: "#9d9d9d",
                  "& .MuiSvgIcon-root": {
                    fontSize: "16px",
                  },
                }}
                onClick={() => handleLogout()}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      display: "flex",
                      justifySelf: "center",
                      marginRight: "5px",
                    }}
                  >
                    <Logout width="16" height="16" />
                  </div>
                  <p style={{ margin: 0, fontWeight: 400 }}>Logout</p>
                </div>
              </MenuItem>
            </Menu>
          </div>
        </div>
      </div>
    </Box>
  );
}
